<template>
  <div
    class="q-img"
    style="height: 400px"
  >
    <NuxtImg
      :preload="{ fetchPriority: 'high' }"
      provider="cloudflare"
      src="/assets/backdrops/facade.jpg"
      height="400"
      fit="cover"
      class="fit"
      sizes="xs:400px sm:600px md:800px lg:1600px"
      style="object-fit: cover; object-position: 50% 50%;"
      alt="The new KYGUNCO Louisville location"
    />
    <div class="q-img__content absolute-full q-anchor--skip">
      <div class="absolute-bottom">
        <div class="text-subtitle2">
          <span class="text-weight-medium">KYGUNCO</span> is your one-stop
          online shop for all things firearms. Headquartered in
          <a
            href="https://www.google.com/maps/dir/?q=place_id:ChIJfwecWCBSaIgRguIjuoPha40"
            target="_blank"
            class="text-link"
          >Bardstown, KY</a>, we offer great deals on all types of firearms,
          <nuxt-link
            class="text-link"
            to="/category/ammunition"
          >ammunition</nuxt-link>,
          <nuxt-link
            class="text-link"
            to="/category/shooting/gun-parts"
          >gun parts</nuxt-link>,
          <nuxt-link
            class="text-link"
            to="/category/optics"
          >optics</nuxt-link>, and accessories. We are proud to carry wide
          selections from top brands such as
          <nuxt-link
            class="text-link"
            to="/brand/smith-wesson"
          >Smith & Wesson</nuxt-link>,
          <nuxt-link
            class="text-link"
            to="/brand/taurus"
          >Taurus</nuxt-link>,
          <nuxt-link
            class="text-link"
            to="/brand/springfield-armory"
          >Springfield Armory</nuxt-link>,
          <nuxt-link
            class="text-link"
            to="/brand/glock"
          >Glock</nuxt-link>
          and
          <nuxt-link
            class="text-link"
            to="/brands"
          >
            many more</nuxt-link>. We
          are dedicated to making the online gun buying process safe and
          simple. <span class="text-weight-medium">KYGUNCO</span> has you
          covered with everything you need from concealed carry and home
          defense to hunting and target shooting.
        </div>
      </div>
    </div>
  </div>
</template>
